import React, { useState } from "react";
import { Item, Parent } from "./TransactionTabRow";
import { isNullOrUndefined } from "../utils/utils";
import { Divider } from "@mui/material";
import { primaryActionColor } from "../utils/constants";

function TableHeaderStrip(props) {
  const [isChecboxChecked, setIsChecboxChecked] = useState(false);
  return (
    <>
      <Parent style={{ flexShrink: 0 }}>
        {/* <input
          type="checkbox"
          sx={{
            padding: "0px",
            color: primaryActionColor,
            "&.Mui-checked": {
              color: primaryActionColor,
            },
          }}
          checked={isChecboxChecked}
          onChange={(e) => {
            setIsChecboxChecked(e.target.checked);
            props.headerCheckboxClicked(e.target.checked);
          }}
        /> */}
        {props.list.map((element, index) => (
          <>
            {(isNullOrUndefined(element[2]) || element[2]) && (
              <Item
                percent={element[0]}
                fontWeight={"500"}
                style={{
                  justifyContent: "center",
                  padding: 0,
                  fontSize: "14px",
                }}
              >
                {element[1]}
              </Item>
            )}
            {index !== props.list.length - 1 && (
              <Divider orientation="vertical" flexItem />
            )}
          </>
        ))}
      </Parent>
      <Divider orientation="horizontal" flexItem />
    </>
  );
}

export default TableHeaderStrip;
